<script lang="ts">
  import StepActionCTA from "../../../step-action-cta"
  let {
    show = false,
    previewError = null,
    optimizationWarning = null,
    retryPending = false,
    onRetry = undefined,
  }: {
    show?: boolean
    previewError?: string | null
    optimizationWarning?: string | null
    retryPending?: boolean
    onRetry?: () => void
  } = $props()
</script>

{#if show && previewError}
  <p class="warning-hint">{previewError}</p>
  {#if onRetry}
    <StepActionCTA
      type="tertiaryButton"
      content="Erneut versuchen"
      onClick={onRetry}
      disabled={retryPending}
    />
  {/if}
{/if}
{#if show && optimizationWarning}
  <p class="warning-hint">{optimizationWarning}</p>
{/if}

<style lang="less">
  .warning-hint {
    margin: 0;
    color: var(--alert-100, #e25555);
    font-weight: 600;
  }
</style>
